// extracted by mini-css-extract-plugin
export default {"announcement":"Announcement_announcement__NlHeC","container":"Announcement_container__wvmmw","marquee":"Announcement_marquee__kuW9I","marqueeItem":"Announcement_marqueeItem__eaiE8"};